import { createContext } from 'preact';
import { Changes, ClickThruOptions, TimeUpdate } from '../../types';

export interface ControlsContextValueType {
  renderSlot: HTMLElement;
  changes: Changes;
  updateTime: (timeUpdate: TimeUpdate) => void;
  clickThru: (clickthru: ClickThruOptions) => void;
  stopAd: () => void;
  setAdLoaded: () => void;
}

export const ControlsContext = createContext({ renderSlot: document.body } as ControlsContextValueType);
